import React from 'react'

export const ViewIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.9834 9.99993C12.9834 11.6499 11.6501 12.9833 10.0001 12.9833C8.35006 12.9833 7.01672 11.6499 7.01672 9.99993C7.01672 8.34993 8.35006 7.0166 10.0001 7.0166C11.6501 7.0166 12.9834 8.34993 12.9834 9.99993Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M9.99999 16.8918C12.9417 16.8918 15.6833 15.1584 17.5917 12.1584C18.3417 10.9834 18.3417 9.00843 17.5917 7.83343C15.6833 4.83343 12.9417 3.1001 9.99999 3.1001C7.05832 3.1001 4.31666 4.83343 2.40833 7.83343C1.65833 9.00843 1.65833 10.9834 2.40833 12.1584C4.31666 15.1584 7.05832 16.8918 9.99999 16.8918Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
)

export const EditIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.945 3.69992L4.78751 10.2174C4.55501 10.4649 4.33001 10.9524 4.28501 11.2899L4.00751 13.7199C3.91001 14.5974 4.54001 15.1974 5.41001 15.0474L7.82501 14.6349C8.16251 14.5749 8.63501 14.3274 8.86751 14.0724L15.025 7.55492C16.09 6.42992 16.57 5.14742 14.9125 3.57992C13.2625 2.02742 12.01 2.57492 10.945 3.69992Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M9.9176 4.7876C10.2401 6.8576 11.9201 8.4401 14.0051 8.6501"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M3.25 17.5H16.75"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
)

export const DeleteIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.75 5.48511C14.2525 5.23761 11.74 5.11011 9.235 5.11011C7.75 5.11011 6.265 5.18511 4.78 5.33511L3.25 5.48511"
      stroke="#E90004"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M7.37512 4.7275L7.54012 3.745C7.66012 3.0325 7.75012 2.5 9.01762 2.5H10.9826C12.2501 2.5 12.3476 3.0625 12.4601 3.7525L12.6251 4.7275"
      stroke="#E90004"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M15.1374 7.85498L14.6499 15.4075C14.5674 16.585 14.4999 17.5 12.4074 17.5H7.59243C5.49993 17.5 5.43243 16.585 5.34993 15.4075L4.86243 7.85498"
      stroke="#E90004"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M8.74744 13.375H11.2449"
      stroke="#E90004"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M8.12488 10.375H11.8749"
      stroke="#E90004"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
)

export const SearchIcon = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.66665 14.4999C11.1644 14.4999 14 11.6644 14 8.16659C14 4.66878 11.1644 1.83325 7.66665 1.83325C4.16884 1.83325 1.33331 4.66878 1.33331 8.16659C1.33331 11.6644 4.16884 14.4999 7.66665 14.4999Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6666 15.1666L13.3333 13.8333"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const AddIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.5 7H10.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 10.5V3.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const SmallArrowDownIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.28 5.96667L8.93333 10.3133C8.42 10.8267 7.58 10.8267 7.06667 10.3133L2.72 5.96667"
      stroke="#535862"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const XIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M6 6L14 14M14 6L6 14"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
)

export const ExportIcon = ({ className = '' }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.7 7.41699C16.7 7.67533 17.925 9.21699 17.925 12.592V12.7003C17.925 16.4253 16.4333 17.917 12.7083 17.917H7.28332C3.55832 17.917 2.06665 16.4253 2.06665 12.7003V12.592C2.06665 9.24199 3.27498 7.70033 6.22498 7.42533"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 12.4999V3.0166"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.7917 4.87467L10 2.08301L7.20837 4.87467"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ImportIcon = ({ className = '' }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.33 7.6748C16.03 7.9073 17.1325 9.2948 17.1325 12.3323V12.4298C17.1325 15.7823 15.79 17.1248 12.4375 17.1248H7.55499C4.20249 17.1248 2.85999 15.7823 2.85999 12.4298V12.3323C2.85999 9.3173 3.94749 7.9298 6.60249 7.6823"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 2.5V12.16"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5125 10.4873L10 12.9998L7.48755 10.4873"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const TaskSquareIcon = ({ className = '' }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.3083 7.40039H14.6834"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.31665 7.40039L5.94165 8.02539L7.81665 6.15039"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.3083 13.2334H14.6834"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.31665 13.2334L5.94165 13.8584L7.81665 11.9834"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.49996 18.3337H12.5C16.6666 18.3337 18.3333 16.667 18.3333 12.5003V7.50033C18.3333 3.33366 16.6666 1.66699 12.5 1.66699H7.49996C3.33329 1.66699 1.66663 3.33366 1.66663 7.50033V12.5003C1.66663 16.667 3.33329 18.3337 7.49996 18.3337Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ResetIcon = () => (
  <svg
    className="w-[20px] h-[20px]"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.7 16.4463C14.56 15.693 16.6667 13.093 16.6667 9.99967C16.6667 6.31967 13.7067 3.33301 10 3.33301C5.55337 3.33301 3.33337 7.03967 3.33337 7.03967M3.33337 7.03967V3.99967M3.33337 7.03967H4.67337H6.29337"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.33337 10C3.33337 13.68 6.32004 16.6667 10 16.6667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="3 3"
    />
  </svg>
)

export const VideoIcon = () => (
  <svg
    className="w-[20px] h-[20px]"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.49996 18.3337H12.5C16.6666 18.3337 18.3333 16.667 18.3333 12.5003V7.50033C18.3333 3.33366 16.6666 1.66699 12.5 1.66699H7.49996C3.33329 1.66699 1.66663 3.33366 1.66663 7.50033V12.5003C1.66663 16.667 3.33329 18.3337 7.49996 18.3337Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.58337 10.0002V8.7669C7.58337 7.17524 8.70837 6.53357 10.0834 7.32524L11.15 7.9419L12.2167 8.55857C13.5917 9.35024 13.5917 10.6502 12.2167 11.4419L11.15 12.0586L10.0834 12.6752C8.70837 13.4669 7.58337 12.8169 7.58337 11.2336V10.0002Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
